export async function serialize(text: string) {
    //const terminal = new Terminal({cols: 65}); // fits fully
    const Terminal = await import("@xterm/xterm")
    const SerializeAddon = await import( "@xterm/addon-serialize")
    const terminal = new Terminal.Terminal({cols: 80});
    const serializeAddon = new SerializeAddon.SerializeAddon();
    terminal.loadAddon(serializeAddon);

    return new Promise(resolve => terminal.write(text, () => {
        const r = serializeAddon.serializeAsHTML();
        console.log("serialzie in", text)
        console.log("serialzie out", r)
        let fragment = r.match(/<!--StartFragment-->(.+)<!--EndFragment-->/)![1]
        // remove base style
        fragment = fragment.replace(/ style='(.+?)'/, "")
        // remove empty lines
        fragment = fragment.replaceAll(/<div><span>\s+<\/span><\/div>/g, "")
        //fragment = fragment.replaceAll(/<span>\s+<\/span>/g, "")
        window.fragment = fragment
        //console.log(fragment)
        resolve(fragment)
    }))
}

export default { serialize }